import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { LessonsState } from '@/store/lessons/types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'
import classRecord from './classRecord'
import preparation from './preparation'
import finalReviewSheet from './finalReviewSheet'

const Lessons: Module<LessonsState, RootState> = {
  state,
  mutations,
  actions,
  getters,
  modules: {
    classRecord,
    preparation,
    finalReviewSheet,
  },
};

export default Lessons;
